import { useDispatch } from 'react-redux';
import { createToast } from 'app/toast';
import { api } from 'utils/axios';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import useInput from '../hook/useInput';

import Button from 'components/Button';
import Toggle from 'components/share/Toggle';
import Input from 'components/Input';

const LinkGenerate = ({ versionId, token, onCancel, track, trackId }) => {
  const { t } = useTranslation();
  const { handleToggle, handleChange, value, isChecked, input, setValue, isToggled } = useInput();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const generateLink = () => {
    let data = {};

    if (!isToggled) {
      data = {
        version: versionId,
        allow_web_play: isChecked,
        play_limit: parseInt(input),
      };
    } else {
      data = {
        allow_web_play: isChecked,
        version: versionId,
      };
    }
    api
      .post('shared/link/', data)
      .then((response) => {
        // Transform URL to use new share domain
        const originalUrl = response.data.url;
        let shareToken = '';

        // Extract token from URL (handle both query param and direct token)
        if (originalUrl.includes('token=')) {
          shareToken = originalUrl.split('token=')[1].split('&')[0];
        } else if (response.data.token) {
          shareToken = response.data.token;
        }

        const shareBaseUrl = process.env.REACT_APP_SHARE_URL || 'https://share.chestmusic.com';
        console.log('REACT_APP_SHARE_URL:', process.env.REACT_APP_SHARE_URL);
        const newShareUrl = `${shareBaseUrl}/shared-link/${shareToken}`;
        setValue(newShareUrl);
        navigator.clipboard.writeText(newShareUrl).then(() => generateToast());
      })
      .catch((error) => {
        console.error('Error al copiar al portapapeles:', error);
      });
  };

  const generateToast = () => {
    let toastBody = {
      title: t('toasts.copy'),
      body: track,
      type: 'copy',
    };

    dispatch(createToast(toastBody));
  };

  return (
    <>
      <div className='share-container !gap-3'>
        <h5 className='font-thunder-bold text-[36px] w-full  text-center'>{t('share.generate_link_subtitle')}</h5>
        <label className='w-full' style={{ fontWeight: '600' }}>
          {t('share.play_limit')}*
        </label>
        <div className=' flex items-center w-full gap-6 h-[50px]'>
          <div className='flex items-center gap-2 h-full'>
            <Toggle onChange={handleToggle} checked={isToggled} />
            <span className={`${!isToggled ? 'text-neutral-silver-300' : ''}`}>{t('share.unlimited')}</span>
          </div>
          {!isToggled && (
            <>
              <Input
                onChange={handleChange}
                required={true}
                type='number'
                disabled={isToggled}
                style={{ height: '44px', width: '70px' }}
                placeholder={1}
              />
              <span>{t('share.play_limit_description')}</span>
            </>
          )}
        </div>
        <div className='w-full mb-5'>
          <button
            className='-mb-7 p-3 bg-brand-gold disabled:bg-neutral-silver-500 rounded-xl 
                                   text-neutral-black disabled:text-neutral-silver-300 h-[46px] flex items-center justify-center'
            onClick={generateLink}
            disabled={!isToggled && !input}
            style={{ fontWeight: '600', width: '100%' }}
          >
            <p>{t('share.generate_link')}</p>
          </button>
        </div>

        <div className='w-full mt-4'>
          <Input showClipboard={true} disabled={true} value={value} showToast={generateToast} />
        </div>
      </div>
      <div className='flex gap-4'>
        <Button
          style='tertiary'
          customStyle='lg:!w-[224px] mt-6 !mx-auto !w-10/12'
          text={t('share_screen.back_to_my_chest')}
          onClick={() => navigate('/my-chest')}
        />
        <Button
          style='tertiary'
          customStyle='lg:!w-[224px] mt-6 !mx-auto !w-10/12'
          text={t('share_screen.go_to_project')}
          onClick={() => navigate(`/my-chest/treasure/${trackId}`)}
        />
      </div>
    </>
  );
};

export default LinkGenerate;
